module.exports = __webpack_public_path__ + "img/ScreenLogin.7c0d3556.png";